"use client";

import {
  EventType,
  GET_EVENTS,
  TimeLineView,
} from "@/graphql/queries/event-query";
import WebinarCard from "./WebinarCard";
import { Grid2 } from "@repo/ui";
import { useSuspenseQuery } from "@apollo/client";
import { useEffect } from "react";

type WebinarProps = {
  timeLineView: TimeLineView;
  setPageInfo: (pageInfo: {
    perPage: number;
    total: number;
    currentPage: number;
  }) => void;
  page: number;
};

const Webinars = ({ timeLineView, setPageInfo, page }: WebinarProps) => {
  const commonParams = {
    eventType: EventType.WEBINAR,
    page: page,
    perPage: 9,
  };

  const { data: webinarEvent } = useSuspenseQuery(GET_EVENTS, {
    variables: {
      ...commonParams,
      timeLineView,
    },
    context: {
      fetchPolicy: "network-only",
    },
  });
  const webinars = webinarEvent?.events?.data ?? [];
  const pageInfo = webinarEvent?.events?.pageInfo;

  useEffect(() => {
    if (pageInfo) {
      setPageInfo({
        perPage: pageInfo.perPage,
        total: pageInfo.total,
        currentPage: pageInfo.currentPage,
      });
    }
  }, [pageInfo, setPageInfo]);

  return (
    <Grid2 container spacing={5}>
      {webinars?.map((webinar) => (
        <Grid2 key={webinar.id} size={12} md={4} lg={4}>
          <WebinarCard
            title={webinar.serviceName}
            eventDates={webinar.eventDates}
            time={webinar.eventDetails.eventTime}
            author={webinar.eventDetails?.trainer?.name}
            pageSlug={webinar.pageSlug}
            coverSrc={webinar.serviceImage}
          />
        </Grid2>
      ))}
    </Grid2>
  );
};

export default Webinars;
